import { post } from '@/base/http-base'

export function describeWechatInfo(data) {
  return post('/uiam/v1/user:describeWechatInfo', data)
}
